import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class HeaderConfigurationService {
    constructor(private http: HttpClient) {}

    // TODO WF-2201
    public configureFiscalizacionesLink(fiscalizaciones, cuit) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
        const base = environment.settings.url_apprentas + '/rentas/rest/svcTokenFiscalizaciones';
        return this.http.post<any>(base, JSON.stringify({ fiscalizaciones, cuit }), httpOptions);
    }
}
